import { createRouter, createWebHashHistory } from 'vue-router';
import LoginForm from '../components/LoginForm.vue';
import HomePage from '../components/HomePage.vue';
import Update from '../components/update.vue';
import Logout from '../components/logout.vue';
import AdminInfo from '../components/admin_info.vue';
import SemesterFind from '../components/semester_find.vue';
import SchoolCourseSummary from '../components/School_Course_Summary.vue';
import SchoolPreparationSummary from '../components/School_Preparation_Summary.vue';
import InternshipCertificate from '../components/Internship_Certificate.vue';
import SchoolLecture from '../components/School_Lecture.vue';
import FindLogs from '../components/find_logs.vue';
import AppConfig from '../components/app_config.vue';
import Deletlogs from '../components/deletlogs.vue';
import CheekPage from '../components/CheekPage.vue'; // 引入新的组件
import SettingComt from '../components/SettingCompT.vue'; // 引入新的组件
import updatecomp from '../components/updatecomp.vue'; // 引入新的组件
import competition_find from '../components/competition_find.vue'; // 引入新的组件
import RequestManager from '../components/RequestManager.vue'; // 引入新的组件
import deletlogscomp from '../components/deletlogscomp.vue'; // 引入新的组件
import find_logs_comp from '../components/find_logs_comp.vue'; // 引入新的组件
import aboutVision from '../components/aboutVision.vue'; // 引入新的组件
import PdfViewerComponent from '../components/PdfViewerComponent.vue'; // 引入新的组件
import change_pwd from '../components/change_pwd.vue'; // 引入新的组件

const routes = [
  { path: '/login', component: LoginForm },
  {
    path: '/',
    component: HomePage,
    meta: { requireLogin: true },
    children: [
      { path: '/update', component: Update },
      { path: '/semester_find', component: SemesterFind },
      { path: '/logout', component: Logout },
      { path: '/adminlog', component: AdminInfo },
      { path: '/School_Course_Summary', component: SchoolCourseSummary },
      { path: '/School_Preparation_Summary', component: SchoolPreparationSummary },
      { path: '/School_Lecture', component: SchoolLecture },
      { path: '/Internship_Certificate', component: InternshipCertificate },
      { path: '/find_logs', component: FindLogs },
      { path: '/app_config', component: AppConfig },
      { path: '/deletlogs', component: Deletlogs },
      { path: '/settingCompetitionTemplates', component: SettingComt },
      { path: '/updatecomp', component: updatecomp },
      { path: '/competition_find', component: competition_find },
      { path: '/request_manager', component: RequestManager },
      { path: '/deletlogscomp', component: deletlogscomp },
      { path: '/find_logs_comp', component: find_logs_comp },
      { path: '/aboutVision', component: aboutVision },
      { path: '/indroduction', component: PdfViewerComponent },
      { path: '/change_pwd', component: change_pwd }
    ]
  },
  { path: '/cheek/:id', component: CheekPage } // 新添加的路由
];

const router = createRouter({
  history: createWebHashHistory(), // 使用哈希模式
  routes
});

export default router;
